<template>
  <div class="main">
    <img width="100%" :src="require('../../assets/images/question/voucher01.jpg')" />
    <div class="quan">
      <img width="100%" :src="require('../../assets/images/question/voucher02.jpg')" />
      <div class="list">
        <div class="m1">
          <div class="mLeft">
            <h2>享道出行体验券</h2>
            <p>有效期：2018.11.18-2018.12.8</p>
          </div>
          <div class="price">
            <span>7</span>折
          </div>
        </div>
        <div class="m2">限上海地区使用，最高抵扣10元</div>
      </div>
    </div>
  </div>
</template>
<script>
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
export default {
  name: 'QuestionsVoucherPage',
  mounted () {
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
  }
}
</script>
<style scoped lang="stylus">
.main{
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: #48c1c8;
}
img{
  display: block;
}
.quan{
  position: relative;
  .list{
    width: 92%;
    background: url(../../assets/images/question/ticket.png);
    background-size: cover;
    border-radius: 5px;
    padding: 0 15px;
    margin-bottom: 15px;
    position: absolute;
    top: 35%;
    left: 4%;
    .m1{
      padding: 1.18rem 0;
      border-bottom: 1px dotted #ddd;
      overflow: hidden;
      .mLeft{
        float: left;
        h2{
          color: #333;
          font-size: 1rem;
        }
        p{
          color: #999;
          font-size: 0.75rem;
        }
      }
      .price{
        float: right;
        color: #00b2a9;
        font-family: Arial, Helvetica, sans-serif;
        span{
          font-size: 2rem;
        }
      }
    }
    .m2{
      padding: 10px 0;
      font-size: 0.7rem;
      color: #aaa;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Questions/voucher.vue